import { AppCheckbox } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useId } from 'react'
import { WORK_LOCATION_LABELS, type WorkLocations } from 'shared'
import { cn } from '@/lib/utils'

/**
 * 作業場所（オンサイト/オフサイト/在宅）チェックボックスグループ
 * - label: グループラベル（省略時はラベルなし）
 * - gap: チェックボックス間の間隔クラス（デフォルト: 'gap-4'）
 * - labelClassName: 各チェックボックスのラベルスタイル
 * - className: 外側コンテナのクラス
 * - value: WorkLocations オブジェクト
 * - onChange: WorkLocations の更新コールバック
 */
export interface AppWorkLocationCheckboxGroupProps {
  label?: string
  gap?: string
  labelClassName?: string
  className?: string
  value: WorkLocations
  onChange: (value: WorkLocations) => void
}

const WORK_LOCATION_KEYS = Object.keys(WORK_LOCATION_LABELS) as (keyof WorkLocations)[]

export function AppWorkLocationCheckboxGroup({
  label,
  gap = 'gap-4',
  labelClassName,
  className,
  value,
  onChange,
}: AppWorkLocationCheckboxGroupProps) {
  const legendId = useId()

  const checkboxes = (
    <div className={cn('flex', gap)}>
      {WORK_LOCATION_KEYS.map((key) => (
        <AppCheckbox
          key={key}
          label={WORK_LOCATION_LABELS[key]}
          checked={value[key]}
          onCheckedChange={(checked) => onChange({ ...value, [key]: checked === true })}
          labelClassName={labelClassName}
        />
      ))}
    </div>
  )

  if (!label) {
    return <div className={className}>{checkboxes}</div>
  }

  return (
    <fieldset aria-labelledby={legendId} className={cn('flex flex-col gap-3', className)}>
      <legend id={legendId} className='text-xs font-medium text-muted-foreground'>
        {label}
      </legend>
      {checkboxes}
    </fieldset>
  )
}
